import React, {Component} from 'react';
import PmListItem from 'components/pm/PmListItem';

import ShortPmList from 'pm-js/build/components/ShortPmList';

class PmList extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div className="pm-conversations-list">
                <ShortPmList
                    conversations={this.props.conversations}
                    filterFn={this.props.filterFn}

                    itemRenderFn={(conv) => <PmListItem key={conv.user.uid} conversation={conv} pathFn={this.props.pathFn} onClick={this.props.onItemClick}/>}/>
            </div>);
    }
}

export default PmList;



// WEBPACK FOOTER //
// ./src/components/pm/PmList.js